import styled from "styled-components";
export const SIZES = {
    MIN_ITEM_HEIGHT: 57,
    ITEMS_GAP: 8
};
export default {
    ItemsContainer: styled.div `
    .virtual-row {
      padding-bottom: ${SIZES.ITEMS_GAP}px;
      > div:first-child {
        min-height: ${SIZES.MIN_ITEM_HEIGHT}px;
      }
    }
  `
};
